/** Vaste toeslagwaarden uit de werkwijze van De Klerk Binnenbouw. */
/** Overmaat die de zaagafdeling standaard aanhoudt; afwijken hiervan is een rode waarde. */
export const STANDAARD_OVERMAAT_MM = 5;
/** Overmaat op de eerste zaagsnede vóór het persen (eis 2.3, stap CNC ZAAG). */
export const OVERMAAT_VOOR_PERSEN_MM = 30;
//# sourceMappingURL=constanten.js.map